import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { StartClient } from "@tanstack/react-start/client";
import { DEFAULT_LOCALE, isValidLocale, loadLocale } from "./lib/i18n";

// The server rendered this page in the URL's locale. Have those strings in
// hand BEFORE hydrating: otherwise React hydrates against English fallbacks,
// mismatches the SSR markup, and the page flashes the wrong language.
// __root.tsx emits a <link rel="preload"> for the same file, so by the time
// the scripts have run the JSON is usually already in the cache.
const first = window.location.pathname.split("/").filter(Boolean)[0] ?? "";
const lang = isValidLocale(first) ? first : DEFAULT_LOCALE;

void loadLocale(lang).then(() => {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <StartClient />
      </StrictMode>,
    );
  });
});
